import { useEffect } from "react"
import Spinner from "@/v2-ui/spinner"
import { logout } from "@/v2-backoffice-client/auth/auth.instance"

function AuthLogoutPage() {
  useEffect(() => {
    logout()
  }, [])

  return (
    <div className="flex items-center justify-center flex-1 bg-background">
      <div className="max-w-md w-full space-y-8 p-8 bg-card rounded-lg shadow-lg border">
        <div className="text-center">
          <h2 className="text-3xl font-bold text-foreground mb-4">
            Logging out...
          </h2>
          <p className="text-muted-foreground mb-6">
            Please wait while we log you out
          </p>
          <Spinner displaySize="md">Logging out...</Spinner>
        </div>
      </div>
    </div>
  )
}

export default AuthLogoutPage
